import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import ChessSet from "@/modules/settings/ChessSet";
import useTranslation from "next-translate/useTranslation";

interface BoardSettingsPopupProps {
  onClose: () => void;
}

export default function BoardSettingsPopup({
  onClose,
}: BoardSettingsPopupProps) {
  const { t } = useTranslation("common");
  const { t: authT } = useTranslation("auth");
  const [isVisible, setIsVisible] = useState(false);

  // Trigger animation on mount
  useEffect(() => {
    requestAnimationFrame(() => {
      setIsVisible(true);
    });
  }, []);

  function handleClose() {
    setIsVisible(false);
    setTimeout(onClose, 200);
  }

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-[9999] p-3 transition-opacity duration-200
        ${isVisible ? "opacity-100" : "opacity-0"}`}
    >
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-200
          ${isVisible ? "opacity-40" : "opacity-0"}`}
        onClick={handleClose}
      />

      {/* Popup content */}
      <div
        className={`relative flex flex-col p-6 w-full max-w-lg bg-white rounded-xl shadow-2xl
          transition-all duration-200 ease-out
          ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-1 text-gray-400 rounded-md transition-colors hover:text-gray-600 hover:bg-gray-100"
        >
          <IoClose className="w-5 h-5" />
        </button>

        {/* Title */}
        <div className="mb-4 text-lg font-semibold text-gray-900">
          {authT("Chess sets")}
        </div>

        {/* Chess set settings component */}
        <ChessSet showTitle={false} />
      </div>
    </div>
  );
}
